import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { LiksPage } from '../../components/liks/LiksPage/LiksPage';
import { LiksTabs } from '../../components/liks/LiksTabs/LiksTabs';
import { useI18n } from '../../i18n/useI18n';
import {
  DEFAULT_SETTINGS_TAB,
  isSettingsTabId,
  resolveSettingsTabPath,
  type SettingsTabId,
} from '../../routes/settingsPaths';
import { SettingsAboutTab } from './tabs/SettingsAboutTab';
import { SettingsAppInfoTab } from './tabs/SettingsAppInfoTab';
import { SettingsProfileTab } from './tabs/SettingsProfileTab';
import './SettingsPage.css';

export function SettingsPage() {
  const { translate } = useI18n();
  const navigate = useNavigate();
  const { tab } = useParams<{ tab?: string }>();

  if (!isSettingsTabId(tab)) {
    return (
      <Navigate to={resolveSettingsTabPath(DEFAULT_SETTINGS_TAB)} replace />
    );
  }

  const activeTabId: SettingsTabId = tab;

  const handleTabChange = (nextTabId: string) => {
    if (!isSettingsTabId(nextTabId)) {
      return;
    }
    navigate(resolveSettingsTabPath(nextTabId));
  };

  const tabs = [
    {
      id: 'profile',
      label: translate('settings.tabs.profile'),
      content: <SettingsProfileTab />,
    },
    {
      id: 'app-info',
      label: translate('settings.tabs.appInfo'),
      content: <SettingsAppInfoTab />,
    },
    {
      id: 'about',
      label: translate('settings.tabs.about'),
      content: <SettingsAboutTab />,
    },
  ];

  return (
    <LiksPage
      className="settings-page"
      size="medium"
      pageAlign="start"
      headerAlign="start"
      contentAlign="start"
      header={<h1>{translate('settings.title')}</h1>}
      content={
        <div className="settings-page__content">
          <LiksTabs
            tabs={tabs}
            activeTabId={activeTabId}
            onActiveTabIdChange={handleTabChange}
            aria-label={translate('settings.tabs.legend')}
          />
        </div>
      }
    />
  );
}
